import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_ProviderSystemsReview = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_ProviderSystemsReview' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <center> <h3> <b> Provider Systems Review Tool </b> </h3> </center>
                </p>

                <p className='w-750'> <center> <h4> <b> A. Program Compliance Review </b> </h4> </center>
                </p>

                <p className='w-750'> <span className='eleHeader'> Proof of current licensure for all case managers. </span>
                </p>

                <p className='w-750'>
                    <input type='radio' id='rbLicensure_Yes' name='rbLicensure' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbLicensure_No' name='rbLicensure' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbLicensure_Na' name='rbLicensure' className='add-only' value='NA' /> NA
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Comments </span>
                    <textarea id='txtComments_1' name='txtComments_1' className='add-only'> </textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> All independently developed marketing materials, including but not limited to, brochures, posters, business cards or website have been submitted to DSHS/HHSC-CM and have been approved by HHSC-CM for use. </span>
                </p>

                <p className='w-750'>
                    <input type='radio' id='rbIndependently_Yes' name='rbIndependently' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIndependently_No' name='rbIndependently' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbIndependently_Na' name='rbIndependently' className='add-only' value='NA' /> NA
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Comments </span>
                    <textarea id='txtComments_2' name='txtComments_2' className='add-only'> </textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Provider information submitted to DSHS/HHSC-CM and TMHP is current and accurate, including case management staff, Conflict of Interest Statements, agency status and demographic information. </span>
                </p>

                <p className='w-750'>
                    <input type='radio' id='rbProvider_Yes' name='rbProvider' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbProvider_No' name='rbProvider' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbProvider_Na' name='rbProvider' className='add-only' value='NA' /> NA
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Comments </span>
                    <textarea id='txtComments_3' name='txtComments_3' className='add-only'> </textarea>
                </p>

                <p className='w-750'> <center> <h4> <b> B. Internal Quality Assurance Review </b> </h4> </center>
                </p>

                <p className='w-750'> <span className='eleHeader'> Provider has a log of all clients referred for case management, including client name, date of birth, client's Medicaid number, date of referral and outcome of referral. </span>
                </p>

                <p className='w-750'>
                    <input type='radio' id='rbManagement_Yes' name='rbManagement' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbManagement_No' name='rbManagement' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbManagement_Na' name='rbManagement' className='add-only' value='NA' /> NA
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Comments </span>
                    <textarea id='txtComments_4' name='txtComments_4' className='add-only'> </textarea>
                </p>


                <p className='w-750'> <b> Provider has an Internal Quality Management System which includes the following: </b> </p>

                <p className='w-750'>
                    <span className='eleHeader'> Internal client record review procedures, including the number of charts to be reviewed, the frequency of the review, and the approved case manager performing the review. (Case managers may perform self-review) </span>
                </p>

                <p className='w-750'>
                    <input type='radio' id='rbInternal_Yes' name='rbInternal' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbInternal_No' name='rbInternal' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbInternal_Na' name='rbInternal' className='add-only' value='NA' /> NA
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Comments </span>
                    <textarea id='txtComments_5' name='txtComments_5' className='add-only'> </textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Internal program review procedures </span>
                </p>

                <p className='w-750'>
                    <input type='radio' id='rbReview_Yes' name='rbReview' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReview_No' name='rbReview' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReview_Na' name='rbReview' className='add-only' value='NA' /> NA
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Comments </span>
                    <textarea id='txtComments_6' name='txtComments_6' className='add-only'> </textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Provider has implemented Internal QMS as evidenced by completed record review tools (CM-16). These completed CM-16s are also maintained in the client's chart. </span>
                </p>

                <p className='w-750'>
                    <input type='radio' id='rbImplemented_Yes' name='rbImplemented' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbImplemented_No' name='rbImplemented' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbImplemented_Na' name='rbImplemented' className='add-only' value='NA' /> NA
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Comments </span>
                    <textarea id='txtComments_7' name='txtComments_7' className='add-only'> </textarea>
                </p>





            </div>
        </form>

    )
}











